import { GroupedTransactionsInterface } from '../models/grouped-transactions.interface';

export const InitialTransactionsGroups: Array<GroupedTransactionsInterface> = [
  {
    label: 'در حال انجام',
    dateStart: new Date(new Date().setDate(new Date().getDate() + 121)).setHours(0, 0, 0, 0),
    dateEnd: new Date(new Date().setDate(new Date().getDate() + 1000)).setHours(0, 0, 0, 0),
    items: [],
    pendingTransaction: true,
  },
  {
    label: 'آینده',
    dateStart: new Date(new Date().setDate(new Date().getDate() + 121)).setHours(0, 0, 0, 0),
    dateEnd: new Date(new Date().setDate(new Date().getDate() + 1000)).setHours(0, 0, 0, 0),
    items: [],
  },
  {
    label: '3 ماه آینده',
    dateStart: new Date(new Date().setDate(new Date().getDate() + 90)).setHours(0, 0, 0, 0),
    dateEnd: new Date(new Date().setDate(new Date().getDate() + 120)).setHours(23, 59, 59, 999),
    items: [],
  },
  {
    label: '2 ماه آینده',
    dateStart: new Date(new Date().setDate(new Date().getDate() + 61)).setHours(0, 0, 0, 0),
    dateEnd: new Date(new Date().setDate(new Date().getDate() + 90)).setHours(23, 59, 59, 999),
    items: [],
  },
  {
    label: 'ماه آینده',
    dateStart: new Date(new Date().setDate(new Date().getDate() + 31)).setHours(0, 0, 0, 0),
    dateEnd: new Date(new Date().setDate(new Date().getDate() + 60)).setHours(23, 59, 59, 999),
    items: [],
  },
  {
    label: '3 هفته آینده',
    dateStart: new Date(new Date().setDate(new Date().getDate() + 22)).setHours(0, 0, 0, 0),
    dateEnd: new Date(new Date().setDate(new Date().getDate() + 30)).setHours(23, 59, 59, 999),
    items: [],
  },
  {
    label: '2 هفته آینده',
    dateStart: new Date(new Date().setDate(new Date().getDate() + 15)).setHours(0, 0, 0, 0),
    dateEnd: new Date(new Date().setDate(new Date().getDate() + 21)).setHours(23, 59, 59, 999),
    items: [],
  },
  {
    label: 'هفته آینده',
    dateStart: new Date(new Date().setDate(new Date().getDate() + 7)).setHours(0, 0, 0, 0),
    dateEnd: new Date(new Date().setDate(new Date().getDate() + 14)).setHours(23, 59, 59, 999),
    items: [],
  },
  {
    label: '6 روز آینده',
    dateStart: new Date(new Date().setDate(new Date().getDate() + 6)).setHours(0, 0, 0, 0),
    dateEnd: new Date(new Date().setDate(new Date().getDate() + 6)).setHours(23, 59, 59, 999),
    items: [],
  },
  {
    label: '5 روز آینده',
    dateStart: new Date(new Date().setDate(new Date().getDate() + 5)).setHours(0, 0, 0, 0),
    dateEnd: new Date(new Date().setDate(new Date().getDate() + 5)).setHours(23, 59, 59, 999),
    items: [],
  },
  {
    label: '4 روز آینده',
    dateStart: new Date(new Date().setDate(new Date().getDate() + 4)).setHours(0, 0, 0, 0),
    dateEnd: new Date(new Date().setDate(new Date().getDate() + 4)).setHours(23, 59, 59, 999),
    items: [],
  },
  {
    label: '3 روز آینده',
    dateStart: new Date(new Date().setDate(new Date().getDate() + 3)).setHours(0, 0, 0, 0),
    dateEnd: new Date(new Date().setDate(new Date().getDate() + 3)).setHours(23, 59, 59, 999),
    items: [],
  },
  {
    label: '2 روز آینده',
    dateStart: new Date(new Date().setDate(new Date().getDate() + 2)).setHours(0, 0, 0, 0),
    dateEnd: new Date(new Date().setDate(new Date().getDate() + 2)).setHours(23, 59, 59, 999),
    items: [],
  },
  {
    label: 'فردا',
    dateStart: new Date(new Date().setDate(new Date().getDate() + 1)).setHours(0, 0, 0, 0),
    dateEnd: new Date(new Date().setDate(new Date().getDate() + 1)).setHours(23, 59, 59, 999),
    items: [],
  },
  {
    label: 'امروز',
    dateStart: new Date().setHours(0, 0, 0, 0),
    dateEnd: new Date().setHours(23, 59, 59, 999),
    items: [],
  },
  {
    label: 'دیروز',
    dateStart: new Date(new Date().setDate(new Date().getDate() - 1)).setHours(0, 0, 0, 0),
    dateEnd: new Date(new Date().setDate(new Date().getDate() - 1)).setHours(23, 59, 59, 999),
    items: [],
  },
  {
    label: '2 روز قبل',
    dateStart: new Date(new Date().setDate(new Date().getDate() - 2)).setHours(0, 0, 0, 0),
    dateEnd: new Date(new Date().setDate(new Date().getDate() - 2)).setHours(23, 59, 59, 999),
    items: [],
  },
  {
    label: '3 روز قبل',
    dateStart: new Date(new Date().setDate(new Date().getDate() - 3)).setHours(0, 0, 0, 0),
    dateEnd: new Date(new Date().setDate(new Date().getDate() - 3)).setHours(23, 59, 59, 999),
    items: [],
  },
  {
    label: '4 روز قبل',
    dateStart: new Date(new Date().setDate(new Date().getDate() - 4)).setHours(0, 0, 0, 0),
    dateEnd: new Date(new Date().setDate(new Date().getDate() - 4)).setHours(23, 59, 59, 999),
    items: [],
  },
  {
    label: '5 روز قبل',
    dateStart: new Date(new Date().setDate(new Date().getDate() - 5)).setHours(0, 0, 0, 0),
    dateEnd: new Date(new Date().setDate(new Date().getDate() - 5)).setHours(23, 59, 59, 999),
    items: [],
  },
  {
    label: '6 روز قبل',
    dateStart: new Date(new Date().setDate(new Date().getDate() - 6)).setHours(0, 0, 0, 0),
    dateEnd: new Date(new Date().setDate(new Date().getDate() - 6)).setHours(23, 59, 59, 999),
    items: [],
  },
  {
    label: 'هفته قبل',
    dateStart: new Date(new Date().setDate(new Date().getDate() - 14)).setHours(0, 0, 0, 0),
    dateEnd: new Date(new Date().setDate(new Date().getDate() - 7)).setHours(23, 59, 59, 999),
    items: [],
  },
  {
    label: '2 هفته قبل',
    dateStart: new Date(new Date().setDate(new Date().getDate() - 21)).setHours(0, 0, 0, 0),
    dateEnd: new Date(new Date().setDate(new Date().getDate() - 15)).setHours(23, 59, 59, 999),
    items: [],
  },
  {
    label: '3 هفته قبل',
    dateStart: new Date(new Date().setDate(new Date().getDate() - 30)).setHours(0, 0, 0, 0),
    dateEnd: new Date(new Date().setDate(new Date().getDate() - 22)).setHours(23, 59, 59, 999),
    items: [],
  },
  {
    label: 'ماه قبل',
    dateStart: new Date(new Date().setDate(new Date().getDate() - 60)).setHours(0, 0, 0, 0),
    dateEnd: new Date(new Date().setDate(new Date().getDate() - 31)).setHours(23, 59, 59, 999),
    items: [],
  },
  {
    label: '2 ماه قبل',
    dateStart: new Date(new Date().setDate(new Date().getDate() - 90)).setHours(0, 0, 0, 0),
    dateEnd: new Date(new Date().setDate(new Date().getDate() - 61)).setHours(23, 59, 59, 999),
    items: [],
  },
  {
    label: '3 ماه قبل',
    dateStart: new Date(new Date().setDate(new Date().getDate() - 120)).setHours(0, 0, 0, 0),
    dateEnd: new Date(new Date().setDate(new Date().getDate() - 91)).setHours(23, 59, 59, 999),
    items: [],
  },
  {
    label: '4 ماه قبل',
    dateStart: new Date(new Date().setDate(new Date().getDate() - 150)).setHours(0, 0, 0, 0),
    dateEnd: new Date(new Date().setDate(new Date().getDate() - 121)).setHours(23, 59, 59, 999),
    items: [],
  },
  {
    label: '5 ماه قبل',
    dateStart: new Date(new Date().setDate(new Date().getDate() - 180)).setHours(0, 0, 0, 0),
    dateEnd: new Date(new Date().setDate(new Date().getDate() - 151)).setHours(23, 59, 59, 999),
    items: [],
  },
  {
    label: '6 ماه قبل',
    dateStart: new Date(new Date().setDate(new Date().getDate() - 210)).setHours(0, 0, 0, 0),
    dateEnd: new Date(new Date().setDate(new Date().getDate() - 181)).setHours(23, 59, 59, 999),
    items: [],
  },
  {
    label: 'گذشته',
    dateStart: -1,
    dateEnd: new Date(new Date().setDate(new Date().getDate() - 211)).setHours(0, 0, 0, 0),
    items: [],
  },
];
